import { Flow } from '@/constants/flow';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';

function getDefaultFlow() {
  if (!navigator.cookieEnabled) return Flow.EXCEPTION_COOKIE_BLOCKED;
  const map = new Map([
    ['/prelogin', Flow.LOGIN_STEP_INPUT_USERNAME],
    ['/register', Flow.REGISTER_STEP_INPUT_USERINFO],
    ['/resetpassword', Flow.RESET_PASSWORD_STEP_INPUT_USERNAME],
    ['/recovery', Flow.RECOVERY_STEP_INPUT_USERNAME],
  ]);

  // Unable to use hooks, can only determine by pathname, remove publicPath
  const pathname = window.location.pathname.toLowerCase();
  if (pathname.includes('/thirdname')) return Flow.THIRD_STEP_SOCIAL_LOGIN;
  return map.get(pathname) || Flow.LOGIN_STEP_INPUT_USERNAME;
}

const defaultFlow = getDefaultFlow();

export const useFlowStore = create(
  combine({ flow: defaultFlow, prevFlow: defaultFlow }, (set) => ({
    setFlow: (flow: Flow) => set((state) => ({ prevFlow: state.flow, flow })),
  })),
);
